import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  formatDocumentTitle,
  useDocumentMetadata,
} from "@/hooks/useDocumentMetadata";
import { EXTERNAL_LINKS } from "@/constants/navigation";
import { getRouteMetadataByPathname, isIndexableRoute } from "@/routes/routeManifest";

export function useRouteDocumentMetadata() {
  const { t } = useTranslation();
  const location = useLocation();
  const currentRoute = getRouteMetadataByPathname(location.pathname);
  const pageTitle = t(currentRoute.titleKey);
  const pageDescription = t(currentRoute.descriptionKey);

  useDocumentMetadata({
    title: formatDocumentTitle(pageTitle, t("brand")),
    description: pageDescription,
    canonicalUrl: currentRoute.id === "notFound"
      ? null
      : new URL(location.pathname.replace(/\/+$/, "") || "/", EXTERNAL_LINKS.website).href,
    indexable: isIndexableRoute(currentRoute),
  });

  return {
    runtimeResetKey: `${location.pathname}${location.search}`,
  };
}
